import { IJourney } from '../journey/journey';
import { IFleet, ITransferCompanies } from '../transferCompany/transferCompany';

export enum OfferType {
  Pending = 'PENDING',
  Notified = 'NOTIFIED',
  SkippedNotification = 'SKIPPED_NOTIFICATION',
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Expired = 'EXPIRED',
  Missed = 'MISSED',
}

export interface IOfferStatus {
  success: boolean;
  status: string;
  journeyId: number;
  journeyCode: string;
}

export const OfferTypeDisplayName = {
  [OfferType.Pending]: 'Pending',
  [OfferType.Notified]: 'Notified',
  [OfferType.SkippedNotification]: 'Skipped notification',
  [OfferType.Accepted]: 'Accepted',
  [OfferType.Declined]: 'Declined',
  [OfferType.Expired]: 'Expired',
  [OfferType.Missed]: 'Missed',
};

export enum JourneyOfferingType {
  Pending = 'PENDING',
  AssignmentInProgress = 'ASSIGNMENT_IN_PROGRESS',
  OfferingPreferred = 'OFFERING_PREFERRED',
  OfferingRemaining = 'OFFERING_REMAINING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Cancelled = 'CANCELLED',
}

export interface IJourneyOffering {
  id: number,
  journeyId: number,
  status: string,
  pickup: IPickup,
  acceptedOffer: IAcceptedOffer,
  created: string,
  updated: string,
  offers: IOfferByIdResults,
  journey: IJourney,
  statusChangeHistory: IStatusChangeHistory,
}

export interface IOfferByIdResults {
  results: IOfferById[]
}

export interface IOfferById {
  id: number,
  created: string,
  fleet: IFleet,
  transferCompany: ITransferCompanies,
  status: string,
  preferred: boolean,
  expiry: string,
}

export interface IPickup {
  dateTime: string,
  timeZoneId: string,
}

export interface IStatusChangeHistory {
  previousStatus: string,
  newStatus: string,
  created: string,
}

export interface IAcceptedOffer {
  acceptedByUserId: number,
  acceptMethod: string,
  created: string,
  offerId: number,
}

export const JourneyOfferingTypeDisplayName = {
  [JourneyOfferingType.Pending]: 'Pending',
  [JourneyOfferingType.AssignmentInProgress]: 'Assignment in progress',
  [JourneyOfferingType.OfferingPreferred]: 'Offering preferred',
  [JourneyOfferingType.OfferingRemaining]: 'Offering remaining',
  [JourneyOfferingType.Accepted]: 'Accepted',
  [JourneyOfferingType.Rejected]: 'Rejected',
  [JourneyOfferingType.Cancelled]: 'Cancelled',
};

export interface IOfferInfoByToken {
  offerId: number;
  journeyId: number;
  journeyCode: string;
  offerStatus: string;
  journeyInbound: boolean;
}
